module.exports = __webpack_public_path__ + "img/icon_new.df50efe7.svg";